import React, {useEffect, useState} from 'react'
import { useParams,useNavigate } from "react-router-dom";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { BranchMenus } from "../../components/recoil/atoms/Menus";

import HeaderBranchTitle from "../components/includes/HeaderBranchTitle";
import { PassedMonths,ChangeSimpleDateString, addThousandPoint, ChangeMobileFormat, GetSimpleDateTimeFromJDateTime,
        isNull,isObjEmpty,unescapeHtml,escapeHtml,GetChildrenState} from "../../components/common/Common";

//수업에 대한 원생 정보
const ToggleClassStudy = () => {
  const { ch_idx,cl_idx } = useParams();
  const [varBranchMenus,setBranchMenus] = useRecoilState(BranchMenus);
  const branch_idx = Number(localStorage.getItem('branch_idx'));

  const navigate = useNavigate();

  //정보저장변수
  const [varMemberInfo,setMemberInfo] = useState({}); //원생정보
  const [varClassInfo,setClassInfo] = useState({});   //수업정보
  const [varPaymentInfo,setPaymentInfo] = useState({}); //결제정보
  const [varAttendanceList,setAttendanceList] = useState([]); //출석내역

  const [varClassStudyChildrenList,setClassStudyChildrenList] = useState([]); //수업별 학생 전체 배열

  const [varModeClass,setModeClass] = useState('disable-only'); 
  const [varSemesterList,setSemesterList] = useState([]);
  //클래스
  const [varClassList,setClassList] = useState([]);
  const [varSelectClassList,setSelectClassList] = useState([]);

  //수강재개를 위해 선택된 클래스의 유효수업수
  const [varClassesStudysCount,setClassesStudysCount] = useState(0);

  //원생 수업상세정보 호출
  const GetClassInformation = async() => {
    const sendData = {branch_idx:branch_idx,ch_idx:ch_idx,cl_idx:cl_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_get_class_toggle`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        if(datas.results.length > 0) setMemberInfo(datas.results[0]);
        //학기배열
        setSemesterList(datas.semesters); 
        //클래스배열
        setClassList(datas.classes);
        //결제정보
        if(datas.paymentInfo.length > 0) setPaymentInfo(datas.paymentInfo[0]);

        //지점의 모든 수업별 학생 전체 배열
        if(datas.classstudys.length > 0) setClassStudyChildrenList(datas.classstudys);

        //현재 원생 관련 수업정보
        if(datas.classInfo.length > 0){
          const dataData = datas.classInfo[0];

          //클래스안의 수업별 정보
          let pindex = 0;
          if(dataData.clc_status === 3) {
            if(Number(cl_idx) > 0) {
              let newList = datas.classstudys.filter(el=>el.cl_idx === Number(cl_idx));
              //console.log(newList);
              setAttendanceList(newList);
              pindex = newList[0].cs_index;
            }
          } else {
            if(datas.studys.length > 0) {
              setAttendanceList(datas.studys);
              pindex = datas.studys[0].cs_index;
            } 
          }
          if(dataData.clc_status === 3) dataData.clc_pindex = pindex;
          dataData.clc_pnumber = 0;
          setClassInfo(dataData);

          const selClassData = datas.classes.find(el=>el.cl_idx===Number(cl_idx));
          setClassesStudysCount(selClassData.rem_studys);
          //수강중지 
          if(dataData.clc_status === 3) setModeClass('');
          //해당 학기에 해당하는 클래스 목록 생성
          ResetClassList(dataData.sm_idx,datas.classes);
        } 
      } else {
        alert(datas.message);
      }
    });
  }

  //최초실행부
  useEffect(() => {
    console.log(varBranchMenus);
    setBranchMenus({showMenu:true,gotoMain:1});
    GetClassInformation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //학기에 해당하는 클래스 목록 생성
  const ResetClassList = (sm_idx,classList) => {
    const newList = classList.filter(el=>el.sm_idx===sm_idx);
    setSelectClassList(newList);
  }

  //수강 재개
  const onChangeInputHandler = (e) => {
    const { name,value } = e.currentTarget;
    if(name === "sm_idx" || name === "cl_idx" || name === "clc_pindex") {
      let inum = Number(value);
      if(name === "clc_pindex") { //수강정지 및 재개시 수업차수
        if(varClassInfo.clc_pindex > 0) {
          const ieffcnt = varClassesStudysCount - (inum - varClassInfo.clc_pindex);
          //console.log(ieffcnt,varClassesStudysCount,inum,varClassInfo.clc_pindex);
          setClassesStudysCount(ieffcnt);
        } 
        if(varClassInfo.clc_status === 3) { //수강중지상태 -> 재개  --> clc_pindex:수업시작작번호
          setClassInfo({...varClassInfo,clc_pindex:inum,clc_pnumber:0});
        } else {  //수강중지 : 정지 시작 차수 --> clc_pindex, 중지된 수업수 --> clc_pnumber
          let pnum = varClassInfo.cl_studys - inum + 1;
          setClassInfo({...varClassInfo,clc_pindex:inum,clc_pnumber:pnum});
        }
      } else {  //수강재개일 경우
        setClassInfo({...varClassInfo,[name]:inum,clc_pnumber:0,clc_pindex:0});
        if(name === "sm_idx") {   //학기선택
          ResetClassList(inum,varClassList);
          setAttendanceList([]);
        } else if(name === "cl_idx") {  //쿨래스선택
          const selClassData = varClassList.find(el=>el.cl_idx===inum);
          //console.log(selClassData,inum);
          console.log(selClassData);
          setClassesStudysCount(selClassData.rem_studys);
          //수업차수
          let newList = varClassStudyChildrenList.filter(el=>el.cl_idx === inum);
          setAttendanceList(newList);
        } else {
          
        }
      }
    } else if(name === "clc_pnumber") {
      //console.log(value);
      let inum = Number(value);
      //const maxCount = inum + varClassInfo.clc_pindex -1;
      //console.log(inum,varClassInfo.clc_pindex,varClassesStudysCount,maxCount);
      //console.log(varAttendanceList,varClassInfo.clc_pindex,inum,varClassesStudysCount);
      if(varClassInfo.smc_store < inum) {
        alert('수강재개로 추가할 수업수가 보유수업수보다 커서 추가할 수 없습니다.'); 
        setClassInfo({...varClassInfo,clc_pnumber:0});
        return false;
      } else if(varClassesStudysCount < inum){ 
        alert('수강재개를 위해 선택된 클래스의 유효한 수업수가 수강재개로 추가할 수업수보다 커서 추가할 수 없습니다.'); 
        setClassInfo({...varClassInfo,clc_pnumber:0});
        return false;
      }
      setClassInfo({...varClassInfo,[name]:inum});
    } else if(name === "clc_pmemo") {
      setClassInfo({...varClassInfo,[name]:escapeHtml(value)});
    } else {
      setClassInfo({...varClassInfo,[name]:value});
    }
  }

  //수강중지 또는 수강재개
  const onChangeClassStatusHandler = async(e) => {
    if(varClassInfo.clc_pindex === 0) {
      alert('차수를 먼저 선택하세요.');
      return false;
    }
    if(varClassInfo.clc_status===3) {
      if(varClassInfo.clc_pnumber === 0) {
        alert('등록할 수업의 수를 먼저 입력하세요.');
        return false;
      }
    }

    let sendData = {dataInfo:varClassInfo,studys:varAttendanceList};
    console.log(sendData);

    let sprompt = "원생의 선택하신 수강을 정지하시겠습니까?";
    if(varClassInfo.clc_status === 3) sprompt = "정지된 원생의 수강을 재개하시겠습니까?";
    if(!window.confirm(sprompt)) {
      return false;
    }

    await axios.post(`${process.env.REACT_APP_HOST}/branch_update_class_toggle`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      alert(datas.message);
      if(datas.retvalue === 1) {
        navigate(`/Branch/ClassInformation/${varClassInfo.cl_idx}`);
      }
    });
  }

  return (
    <div className="vh-content center-view-wrap">
      <HeaderBranchTitle varPageTitle={'수강 정지/재개'} />
      <div className="vh-content-body">
        {/* 원생정보 */}
        <div className="class-info">
          <div className="class-left">
            <div className="name">{varMemberInfo.ch_name}</div>
            <div>{PassedMonths(varMemberInfo.ch_birthday)+"개월"} ({ChangeSimpleDateString(varMemberInfo.ch_birthday)}) ({GetChildrenState(varMemberInfo.ch_status)})</div>
          </div>
        </div>
        <div className="view-con st02">
          <div className="center-wrap">
            {/* 결제정보 */}
            <div className="con con02">
              <div className="con-tit">결제 현황
                <div className="con-state">
                  <span>{isObjEmpty(varPaymentInfo)?"미청구":"결제완료"}</span>
                  <span>{isObjEmpty(varPaymentInfo)?"":`₩ ${addThousandPoint(varPaymentInfo.ph_price)} 원`}</span>
                </div>
              </div>
              {isObjEmpty(varPaymentInfo)?null
              :
                <div className="con-box">
                  <ul>
                    <li>
                      <p>청구서 구분</p>
                      <div>{varPaymentInfo.cl_name}</div>
                    </li>
                    <li>
                      <p>수업 구분</p>
                      <div>{varPaymentInfo.cl_mode===1?"정규수업":"보강수업"}</div>
                    </li>
                    <li>
                      <p>학부모</p>
                      <div>{varPaymentInfo.mem_name} ({ChangeMobileFormat(varPaymentInfo.mem_mobile)})</div>
                    </li>
                    <li>
                      <p>청구서 ID</p>
                      <div>{varPaymentInfo.ivc_id}</div>
                    </li>
                    <li>
                      <p>결제 상태</p>
                      <div>{varPaymentInfo.ph_status===1?"결제대기":"결제완료("+GetSimpleDateTimeFromJDateTime(varPaymentInfo.ph_pdate)+")"} </div>
                    </li>
                  </ul>
                </div>
              } 
            </div>
            {/* 수업정보 */}
            <div className="con con04">
              <div className="con-tit">{varClassInfo.clc_status===3?"수강 재개":"수강 정지"}</div>
              <div className="con-box" style={{marginTop:"0px"}}>
                <div className="input-line">
                  <p>보유현황(미배정수업수)</p>
                  <div className="field-group" style={{fontSize:"13px"}}>{varClassInfo.smc_store} 수업</div>
                </div>
                <div className="input-line">
                  <p>학기명</p>
                  <div className="field-group">
                    <select name="sm_idx" className={`field-select ${varModeClass}`} value={varClassInfo.sm_idx} onChange={e=>onChangeInputHandler(e)}>
                      <option value={0}>학기선택</option>
                      {varSemesterList.map((semesters,i)=>(
                        <option key={'semesters_'+i} value={semesters.sm_idx}>{semesters.sm_name}</option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="input-line">
                  <p>클래스명</p>
                  <div className="field-group">
                    <select name="cl_idx" className={`field-select ${varModeClass}`} value={varClassInfo.cl_idx} onChange={e=>onChangeInputHandler(e)}>
                      <option value={0}>클래스선택</option>
                      {varSelectClassList.map((classes,i)=>(
                        <option key={'classes_'+i} value={classes.cl_idx}>{classes.cl_name}</option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="input-line">
                  <p>차수</p>
                  <div className="field-group">
                    <select name="clc_pindex" value={varClassInfo.clc_pindex} onChange={e=>onChangeInputHandler(e)}>
                      <option value={0}>차수선택</option>
                      {varAttendanceList.map((studys,i)=>(
                        <option key={'studys_'+i} value={studys.cs_index}>{studys.cs_index}차수업</option>
                      ))}
                    </select>
                  </div>
                </div>
                {varClassInfo.clc_status === 3?
                  <div className="input-line">
                    <p>배정할 수업수</p>
                    <div className="field-group">
                      <input type="number" name="clc_pnumber" style={{width:"90px"}} value={varClassInfo.clc_pnumber===0?"":varClassInfo.clc_pnumber} onChange={e=>onChangeInputHandler(e)}></input>
                    </div>
                  </div>
                :
                  <div className="input-line">
                    <p>사유</p>
                    <div className="field-group">
                      <textarea name="clc_pmemo" value={unescapeHtml(varClassInfo.clc_pmemo)} onChange={e=>onChangeInputHandler(e)}/>
                    </div>
                  </div>
                }
              </div>
              <button className="btn-yes" style={{width:"100%",marginTop:"10px"}} onClick={e=>onChangeClassStatusHandler(e)}>
                  {varClassInfo.clc_status===3?"수강 재개하기":"수강 정지하기"}
              </button>
            </div>
            <div className="con con03">
                <div className="con-tit">출결 현황</div>
                <div className="con-box">
                  <ul style={{height:"auto",overflow:"hidden"}}>
                    {varAttendanceList.map((attendance,j)=>(
                      <li key={'attendance_'+j}>
                        <p>{attendance.cs_index}차 수업</p>
                        <div>{attendance.cl_name}&nbsp;:&nbsp;
                            {isNull(attendance.csc_idx)?"수강없음"
                            :attendance.csc_status===1?`예정 : ${ChangeSimpleDateString(attendance.cs_date)} ${attendance.cs_hour}:${attendance.cs_minute}`
                            :attendance.csc_status===2?`출석 : ${GetSimpleDateTimeFromJDateTime(attendance.csc_rdate)}`
                            :attendance.csc_status===3?"결석":"종료"}
                          </div>
                      </li>
                    ))}
                  </ul>
                </div>
            </div>
          </div>
        </div>
			</div>
    </div>
  )
}
export default ToggleClassStudy;